import React, { useEffect, useRef, useState } from 'react';
import axios from '../axiosConfig';
import { handleError, toastError, toastErrorUniqueInfinite, toastSuccess } from '../funciones.js';
import logoInscriptos from '../assets/logoInscriptos.png';
import logoEliminar from '../assets/logoEliminar.png';
import logoEditar from '../assets/logoEditar.png';
import DeseaCancelar from './DeseaCancelar.js';
import { EmpresasInscriptas } from './EmpresasInscriptas.js'; 
import { CrearEventoN } from './CrearEventoN.js';
import { useEventsQuery } from '../hooks/useEventsQuery.jsx';
import { TablaN } from './TablaN.js';
import { AdminUserModals } from './AdminUserModals.jsx';
import { useAdminUsers } from '../hooks/useAdminUsers.jsx';

export const EventsAdmin = (props) => {


    const [idElemSeleccionado, setIdElemSeleccionado] = useState("");
    const [evento, setEvento] = useState({ nombre: '' });
    const { events, loading, refresh, removeEvent } = useEventsQuery("evento/todosLosEventos", { size: 100000 });

    const updateHandlerRef = useRef(() => { });

    const admin = useAdminUsers({
        onUpdateCompany: (...args) => updateHandlerRef.current(...args)
    });
    const [selectedCompany, setSelectedCompany] = useState(admin.profilePlaceholder);

    useEffect(() => {
        setEvento(props.evento)
    }, [props.evento])

    useEffect(() => {
        admin.setIdElemSeleccionado(selectedCompany.id);
    }, [selectedCompany])

    function eliminarEvento(id) {
        const params = {
            params: {
                id: id
            }
        }
        axios
            .delete(process.env.REACT_APP_URL + 'evento', params)
            .then((res) => {
                //cambiarEvento(id, 0);
                removeEvent(id);
                toastSuccess("Evento eliminado");
            })
            .catch(function (error) {
                toastError(handleError(error))
            })
    }

    function mostrarInscriptos() {
        props.setNombreBuscar('')
        //document.getElementById("buscarText").value = ''
        //document.getElementById("containerInscriptos").classList.add("transform-none");
        props.setShowedModals(prev => [...prev, 'registered'])
        /* document.getElementById("txt-nuevo-evento").classList.add("d-none");
         document.getElementById("txt-cerrar").classList.remove("d-none");
         document.getElementById("btnCrearEvento").classList.add("bg-color-cerrar");*/
    }

    function mostrarEditar() {
        props.setNombreBuscar('')
        // document.getElementById("buscarText").value = '' 
        props.setShowedModals(prev => [...prev, 'create'])
        /*document.getElementById("containerCrear").classList.add("transform-none");
        document.getElementById("txt-nuevo-evento").classList.add("d-none");
        document.getElementById("txt-cerrar").classList.remove("d-none");
        document.getElementById("btnCrearEvento").classList.add("bg-color-cerrar");*/
    }

    function showEvent(elem) {
        return elem.nombre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
            .includes(props.search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
    }

    const contentEvent = (elem) => {
        return (
            <>
                <div className='col-sm col-12 mb-3 mb-sm-0 nombreEventoMobile'>
                    {elem.nombre}
                </div>
                <div className='col text-center ocultar-901-750 ocultar-901-450'>
                    {elem.fecha}
                </div>
                <div className='col text-center ocultar660'>
                    {elem.horaInicio + " / " + elem.horaFin}
                </div>
                <div className='text-end col-sm-3 col centrarMobile col-660'>
                    <div className='d-inline-block cursor-pointer' onClick={() => { setEvento(elem); mostrarInscriptos() }}><div className='d-inline-block'>{elem.cantInscriptos}</div>
                        <img className=' img-blanco-mobile translateY--2px ms-1' src={logoInscriptos} alt="" /></div>
                    <img className='ms-3 cursor-pointer img-blanco-mobile translateY--2px' src={logoEditar} alt="" onClick={() => { setEvento(elem); mostrarEditar() }} />
                    <img className='ms-3 cursor-pointer img-blanco-mobile translateY--2px' src={logoEliminar} alt="" data-bs-toggle="modal"
                        data-bs-target="#eliminarEvento" onClick={() => setIdElemSeleccionado(elem.id)} />

                </div>
            </>
        );
    };


    return (
        <>

            <CrearEventoN refresh={refresh} nombreBuscar={props.search} setNombreBuscar={props.setNombreBuscar}
                evento={evento} setIdElemSeleccionado={setIdElemSeleccionado} setPerfil={setSelectedCompany}
                show={props.showedModals.includes('create')} updateHandlerRef={updateHandlerRef} setShowedModals={props.setShowedModals}
                setSelectedCompany={setSelectedCompany} showedModals={props.showedModals} />
            <EmpresasInscriptas evento={evento} funciones={{
                updateHandlerRef: updateHandlerRef, setSelectedCompany: setSelectedCompany,
            }} nombreBuscar={props.search} show={props.showedModals.includes('registered')} />

            <TablaN elementos={events}
                itemsEncabezado={[
                    { className: 'col', text: 'Evento' },
                    { className: 'col text-center ocultar-901-750', text: 'Fecha' },
                    { className: 'col text-center ocultar660', text: 'Horarios' },
                    { className: 'col-sm-3 col-660', text: '' }
                ]} ocultarEncabezadoMobile={true}
                itemsFilas={contentEvent} elemNoEncontrado={'eventos'}
                mostrarElem={showEvent} mostrarLoader={loading} />
            <DeseaCancelar funcionAdmin={() => eliminarEvento(idElemSeleccionado)} id={'eliminarEvento'} />
            <AdminUserModals {...admin} perfil={selectedCompany} />
        </>
    );
}